<template>
  <!-- 进度条 -->
  <div class="progress" ref="progress">
    <div class="line">
      <div class="lineprogress">
        <div v-for="(item, index) in listitem"  :key="index"  class="linewrap">
          <div v-if="index === 0 || index === 13" class="lineother"></div>
          <div :class="'lineitem'+(index+1<lotteryNum*2?' lineitemactive': '')" v-else></div>
        </div>

      </div>
      <div v-for="(item, index) in list" :key="index" class="item">
        <div :class="'gift'+(index+1 <= lotteryNum ? ' giftactive' : '')" v-if="[1,3,6].includes(index)"></div>
        <div :class="'dot'+(index+1 <= lotteryNum ? ' dotactive': '')" v-else ></div>
        <div class="text">{{item}}</div>
        <div class="tip" v-if="[1,3,6].includes(index)"></div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'progress',
  data() {
    return {
      // lotteryNum: 4,
      list: ['第1次', '第2次', '第3次', '第4次', '第5次', '第6次', '第7次'],
      listitem: new Array(14).fill()
    }
  },
  computed: {
    ...mapState([
      'lotteryNum'
    ])
  }
}
</script>

<style lang="less" >
.progress {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 126px/2;
  margin-top: 6px;

  .line {
    position: relative;
    display: flex;
    width: 100%;
    height: 3px;
    background: transparent;
    border-radius: 2px;

    .item {
      position: relative;
      flex: 1;
      text-align: center;

      .tip {
        position: absolute;
        top: -32px;
        left: -3px;
        width: 50px;
        height: 19px;
        background: url(../../assets/images/progress_shiwu.png) no-repeat;
        background-size: 100% 100%;
      }
    }

    .lineactive {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      background: #cc0f0f;
    }
  }

  .text {
    margin-top: 4px;
    font-size: 10px;
    color: #934f14;
  }

  .dot {
    width: 39px/2;
    height: 48px/2;
    margin: -13px auto 0;
    background-image: url(../../assets/images/progress_last.png);
    background-position: center 7px;
    background-size: 26px/2 26px/2;
    background-repeat: no-repeat;
  }

  .dotactive {
    background-image: url(../../assets/images/progress_before.png);
  }

  .gift {
    width: 39px/2;
    height: 48px/2;
    margin: -13px auto 0;
    background-image: url(../../assets/images/progress_close.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .giftactive {
    width: 51px/2;
    height: 48px/2;
    background-image: url(../../assets/images/progress_open.png);
  }

  .lineprogress {
    position: absolute;
    left: 0;
    display: flex;
    width: 100%;
  }

  .linewrap {
    flex: 1;
    height: 3px;
  }

  .lineitem {
    flex: 1;
    height: 3px;
    background: #ff9824;
  }

  .lineitemactive {
    background: #cc0f0f;
  }

  .lineother {
    flex: 1;
    height: 3px;
    background: transparent;
  }
}
</style>
